import { useQuery } from "@tanstack/react-query"

import { apiContextFetch } from "./base"
import { useApiContext } from "./use-api-context"

interface SequenceEnrollmentStats {
  active_enrollment_count: number
  total_enrollment_count: number
  enrollment_limit: number
  remaining_enrollment_slots: number
  can_enroll: boolean
}

interface SequenceEnrollmentStatsOptions {
  emailIntegrationId?: string | null
  enabled?: boolean
}

export const useFetchSequenceEnrollmentStats = (options: SequenceEnrollmentStatsOptions = {}) => {
  const getContext = useApiContext()
  const { emailIntegrationId, enabled = true } = options

  return useQuery<SequenceEnrollmentStats>({
    queryKey: ["sequence-enrollment-stats", "email-integrations", emailIntegrationId ?? "all"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context")

      const query = emailIntegrationId ? `?email_integration_id=${encodeURIComponent(emailIntegrationId)}` : ""
      return apiContextFetch<SequenceEnrollmentStats>(context, `/sequence_enrollment_stats${query}`)
    },
    enabled,
  })
}

export const useFetchSequenceEnrollmentStatsForSequence = (
  sequenceId: string | null | undefined,
  options?: { enabled?: boolean }
) => {
  const getContext = useApiContext()

  return useQuery<SequenceEnrollmentStats>({
    queryKey: ["sequence-enrollment-stats", "sequence", sequenceId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context")

      if (!sequenceId) throw new Error("Sequence ID is required")

      return apiContextFetch<SequenceEnrollmentStats>(context, `/sequence_enrollment_stats/sequence/${sequenceId}`)
    },
    enabled: Boolean(sequenceId) && (options?.enabled ?? true),
  })
}
